import { useMemo, useState } from 'react';
import { EscalationContext } from './EscalationContext';

const EscalationProvider = ({ children }: { children: React.ReactNode }) => {
    const [escalationType, setEscalationType] = useState('');
    const [contactsEscalation, setContactsEscalation] = useState<string[]>([]);

    const value = useMemo(
        () => ({
            escalationType,
            contactsEscalation,
            setEscalationType,
            setContactsEscalation,
        }),
        [escalationType, contactsEscalation],
    );

    return <EscalationContext.Provider value={value}>{children}</EscalationContext.Provider>;
};

export default EscalationProvider;
